export const GET_GROUP_INFO = 'GET_GROUP_INFO';
